// extracted by mini-css-extract-plugin
module.exports = {"Search":"Search__2S5BO","Search_form":"Search_form__2S5BO","Search_error":"Search_error__2S5BO","Search_numberOfResults":"Search_numberOfResults__2S5BO"};